import type { BrandDetails } from '@/features/brands';
import type { SearchableOption } from '@/shared/components/searchable-select';

/*
 * Display only: the catalogue API decides every state; these pick the badge
 * shown beside an option.
 */

export type BrandDenomination = BrandDetails['denominations'][number];
export type CountryState = BrandDenomination['countries'][number];

/** How a denomination stands in this country, beside its option. */
export function denominationHint(state: CountryState | undefined): SearchableOption['hint'] {
  if (!state) return undefined;
  if (!state.offered) return { text: 'Not offered', variant: 'neutral' };
  if (!state.sellable) return { text: 'Cannot be bought', variant: 'danger' };
  if (state.unusableProviders.length > 0) return { text: 'Fallback broken', variant: 'warning' };
  return undefined;
}
